export interface ProductBenefitsProps {
  /** Ya resueltos en el idioma activo por `contentFor`. */
  benefits: readonly string[];
}

/**
 * Los beneficios del producto, como fichas.
 *
 * ── Por qué dejaron de ser una lista con palomitas ───────────────────
 * La ficha original los pinta como una fila de etiquetas pequeñas en
 * mayúsculas, y no como una lista con marcas de verificación. La lista
 * con palomitas empuja el bloque a lo alto y compite con los pilares y
 * los ingredientes, que abajo dicen lo mismo con más detalle. En fila,
 * los beneficios se leen de un vistazo y ceden el peso al texto.
 *
 * ── Sigue siendo una `<ul>` de verdad ────────────────────────────────
 * Un lector de pantalla anuncia "lista de 3 elementos" y quien escucha
 * sabe cuánto falta. Una fila de `<span>` decorados se lee como prosa
 * suelta con las palabras pegadas.
 *
 * ── El contraste de la etiqueta ──────────────────────────────────────
 * `ds-purple` (#6B5B95) sobre `ds-mist` (#E8E3EF) da 4.64:1 — pasa el
 * 4.5:1 que exige un texto de 11 px, pero por poco, así que el tamaño no
 * puede bajar de ahí. `ds-ink-4` sobre el mismo fondo se quedaría en
 * 2.6:1 y está desterrado del texto legible.
 */
export function ProductBenefits({ benefits }: ProductBenefitsProps) {
  if (benefits.length === 0) return null;

  return (
    <ul className="flex flex-wrap gap-2">
      {benefits.map((benefit) => (
        <li
          key={benefit}
          className="rounded-ds-pill bg-ds-mist px-3 py-1.5 text-[11px] font-semibold uppercase tracking-ds-label text-ds-purple"
        >
          {benefit}
        </li>
      ))}
    </ul>
  );
}
